import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Dashboard from "./components/dashboard/Dashboard";
import VoiceRecorder from "./components/recording/VoiceRecorder";
import ImageCapture from "./components/recording/ImageCapture";
import Results from "./components/results/Results";
import AuthGuard from "./components/auth/AuthGuard";
import Footer from "./components/layout/Footer";
import EntryView from "./pages/EntryView";
import EntriesView from "./pages/EntriesView";
import ConfigPage from "./pages/Config";

const queryClient = new QueryClient();

const App = () => {
  // Apply dark mode to the document
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthGuard>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/voice-record" element={<VoiceRecorder />} />
              <Route path="/image-capture" element={<ImageCapture />} />
              <Route path="/results" element={<Results />} />
              <Route path="/entry/:entryId" element={<EntryView />} />
              <Route path="/entries" element={<EntriesView />} />
              <Route path="/config/*" element={<ConfigPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthGuard>
        </BrowserRouter>
        <Footer />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
